// @flow
import React, { Component } from 'react'
import { Button, Card, message, Spin } from 'antd';
import { StyledMember, StyledContent } from './style'
import ReactMarkdown from 'react-markdown'
import {withRouter} from 'react-router-dom';
import {numberFormatter, getQueryString} from '../../utils/common'
import ApiService from '../../actions/apiService';

class MentoringPackage extends Component<Props> {

  state: State = {
    packageName: "1 on 1 Mentoring Package",
    price: 2995,
    isLoading: true,
    content: ''
  }
  
  async componentWillMount() {
    const coupenCode = getQueryString('couponcode');
    this.getContent();
    if (coupenCode) {
      const response = await ApiService.getMethod(`/purchases/checkcoupon?couponCode=${coupenCode}`);
      if (response && response.validCoupon) {
        this.props.history.push({
          pathname: '/checkout',
          state: {
            packageId: 1,
            packageName: this.state.packageName,
            price: this.state.price,
            planLength: '',
            planType: 'onetime',
            promoCode: coupenCode,
          }
        })
      } else {
        message.error('Coupen code is not valid!');
      }
    }
  }
  
  getContent = async () => {
    const response = await ApiService.getMethod(`/description/product/1on1mentoring`);
    if (response) {
      this.setState({
        content: response,
        isLoading: false
      })
    } else {
      this.setState({
        isLoading: false
      })
    }
  }

  handleCart = () => {
    const {packageName, price} = this.state
      this.props.history.push({
        pathname: '/checkout',
        state: {
          packageId: 1,
          packageName: packageName,
          price: price,
          planLength: '',
          planType: 'onetime'
        }
      })
  }

  render() {
    const {isLoading, content} = this.state;
    return (
      <StyledContent>
            <StyledMember>
              <Card title="1 on 1 Mentoring Package" bordered={false}>
                {
                  isLoading && <Spin />
                }
                {
                  !isLoading &&
                  <div>
                    <p className="price-title">$ {numberFormatter(this.state.price)}</p>
                    <ReactMarkdown escapeHtml={false} source={content || ''}/>
                    <Button type="primary" size="large" onClick={this.handleCart}>Checkout</Button>
                  </div>
                }
              </Card>
            </StyledMember>
      </StyledContent>
    )
  }
}

export default withRouter(MentoringPackage)



// WEBPACK FOOTER //
// ./src/components/shop-pages/mentoringPackage.js